import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { stepsConfig, StepId } from "../step-config";

export function useStepper() {
  const navigate = useNavigate();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const stepParam = params.get("step") as string | null;

  const all = stepsConfig;
  const currentIndex = Math.max(
    0,
    all.findIndex((s) => s.id === (stepParam as StepId))
  );

  const step = all[currentIndex] ?? all[0];

  const setStep = (idx: number) => {
    const safe = Math.min(Math.max(idx, 0), all.length - 1);
    const next = new URLSearchParams(location.search);
    next.set("step", all[safe].id);
    navigate({ pathname: location.pathname, search: next.toString() }, { replace: true });
  };

  return useMemo(
    () => ({
      steps: all,
      index: currentIndex,
      step,
      setStep,
      next: () => setStep(currentIndex + 1),
      prev: () => setStep(currentIndex - 1),
    }),
    [currentIndex, location.key]
  );
}


